import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';
import { connect } from 'react-redux';
import withRouterHooks from 'utils/routerHelper';
import CancelSuccessMessage from './cancelSuccessMessage';

class TaskCancelDialog extends React.Component {
  _cancel() {
    if (this.props.dataIds.length === 1) {
      this.props.dispatch(ReduxActions.task.cancel(this.props.dataIds[0]))
        .then(() => {
          Utils.Dialog.DialogManager.close();
          Utils.SuccessMessage.SuccessMessageManager.flash(<CancelSuccessMessage count={1} />);
          if (this.props.shouldPopRoute) {
            this.props.navigate('/tasks');
          }
        })
        .catch(() => {
          Utils.Dialog.DialogManager.close();
          Utils.SuccessMessage.SuccessMessageManager.flash(
            <div className="vf-task__cancel-dialog__error-message">
              {Utils.TranslationHelper.replaceTag(this.props.strings.cancelDialog.errorMessage, {
                count: 1,
              })}
            </div>,
          );
        });
    }
  }

  render() {
    const strings = this.props.strings.cancelDialog;
    return (
      <div className="vf-task__cancel-dialog">
        <div className="vf-task__cancel-dialog__header">
          <Components.CircleIcon
            className="vf-task__cancel-dialog__header__icon"
            iconClassName="versa-warning"
            iconText=""
            innerIconColor={Theme.Color.$red}
            outerIconColor={Theme.Color.$redlighter}
          />
          <span className="vf-task__cancel-dialog__header__text">
            {strings.header}
          </span>
        </div>

        <div className="vf-task__cancel-dialog__description">
          {strings.line1}
        </div>

        <div className="vf-task__cancel-dialog__buttons">
          <Components.Button
            className="vf-task__cancel-dialog__buttons__cancel"
            id="vf-task__cancel-dialog__cancel-button"
            onClick={() => Utils.Dialog.DialogManager.close()}
          >
            {strings.cancelButton}
          </Components.Button>
          <Components.Button
            className="vf-task__cancel-dialog__buttons__confirm"
            id="vf-task__cancel-dialog__confirm-button"
            onClick={() => this._cancel()}
          >
            {strings.confirmButton}
          </Components.Button>
        </div>
      </div>
    );
  }
}

TaskCancelDialog.displayName = 'Task Delete Dialog';

TaskCancelDialog.propTypes = {
  dataIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  dispatch: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  shouldPopRoute: PropTypes.bool,
  strings: PropTypes.shape({
    cancelDialog: PropTypes.shape({
      errorMessage: PropTypes.string,
      header: PropTypes.string,
      line1: PropTypes.string,
      cancelButton: PropTypes.string,
      confirmButton: PropTypes.string,
    }),
  }).isRequired,
};

TaskCancelDialog.defaultProps = {
  shouldPopRoute: false,
};

export default withRouterHooks(connect()(translate('Task')(TaskCancelDialog)));
